import { dateFilterMethodOptions } from '../../filters-form';

interface DateFilterMethodBadge {
  postDateIntervalEnabled: boolean;
  lifetimeInsightsEnabled: boolean;
}

export const useDateFilterMethodBadge = ({ postDateIntervalEnabled, lifetimeInsightsEnabled }: DateFilterMethodBadge) => {
  // Determine current date filter method based on boolean values
  const getCurrentDateFilterMethod = () => {
    if (postDateIntervalEnabled && lifetimeInsightsEnabled) {
      return dateFilterMethodOptions.find((option) => option.value === 'post_date_lifetime');
    } else if (postDateIntervalEnabled) {
      return dateFilterMethodOptions.find((option) => option.value === 'post_date_current');
    } else {
      return dateFilterMethodOptions.find((option) => option.value === 'insight_date');
    }
  };

  const currentMethod = getCurrentDateFilterMethod();

  return {
    dateFilterMethodBadgeProps: {
      data: currentMethod ? [{
        value: currentMethod.value,
        label: currentMethod.label,
        description: currentMethod.description
      }] : [],
    }
  };
};
